import { __awaiter } from "tslib";
import React from 'react';
import { usePositionStyle } from '../../common/position';
import { GraphConfig, createX6GraphModule } from '../graph';
import { useExtensionRegistry } from './extension-context';
import { useXflowPrefixCls } from './global-config-context';
import { usePortal } from '@antv/x6-react-shape';
import { useXFlowApp } from './app-context';
export const XFlowCanvas = props => {
    const app = useXFlowApp();
    /** x6画布parent的dom节点 */
    const rootRef = React.useRef(null);
    /** x6画布的dom节点 */
    const canvasRef = React.useRef(null);
    /** 生成配置中心 */
    const extensionRegistry = useExtensionRegistry();
    /** 获取ContextService的配置 */
    const graphConfig = React.useMemo(() => {
        const config = props.config ? props.config : new GraphConfig();
        config.setX6Config();
        return config;
        /** 保证只生成一次 */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /** X6_NODE_PORTAL_NODE_VIEW */
    const [Portal, setGraph] = usePortal(graphConfig.graphId);
    React.useEffect(() => {
        app &&
            app.getGraphInstance().then(graph => {
                setGraph(graph);
            });
    }, [app, setGraph]);
    React.useEffect(() => {
        /** 设置画布parent dom节点、画布dom节点 */
        graphConfig.setRootContainer(rootRef.current);
        graphConfig.setGraphContainer(canvasRef.current);
        /** 关联XflowApp和Graph*/
        graphConfig.xflowInstanceId = extensionRegistry.getInstaceId();
        extensionRegistry.addCoreModule({ config: graphConfig, createModule: createX6GraphModule });
        /** unmount */
        const destroy = () => __awaiter(void 0, void 0, void 0, function* () {
            graphConfig.dispose();
        });
        return () => {
            destroy();
        };
        /** 保证只生成一次 */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const style = usePositionStyle(props.position);
    const rootClz = useXflowPrefixCls('canvas-root');
    const canvasClz = useXflowPrefixCls('x6-canvas');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: rootRef, className: rootClz, style: style, id: graphConfig.graphId, tabIndex: 0 },
            React.createElement("div", { ref: canvasRef, className: canvasClz }),
            props.children),
        React.createElement(Portal, null)));
};
XFlowCanvas.defaultProps = {
    isXFlowCanvas: true,
};
//# sourceMappingURL=canvas.js.map